import React from "react";

import styles from "./HeaderLayout.module.scss";

export default function HeaderLayout({ headerContent, ...props }) {
  return (
    <div className={styles.headerLayoutWrapper}>
      <div className={styles.headerContent}>{headerContent}</div>
      <div className={styles.content}>{props.children}</div>
    </div>
  );
}
